
import "./billingSheet.css";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { findClientById, addComment, getAllComments } from "../../api";
import Header from "../../Components/Header/Header";
import EditComment from "./EditComment";
import DeleteComment from "./DeleteComment";
import americanExpress from "../../Assets/americanExpressLogo.png";
import visa from "../../Assets/visaLogo.png";
import discover from "../../Assets/discoverLogo.png";
import masterCard from "../../Assets/masterCard.png";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import BorderColorRoundedIcon from "@mui/icons-material/BorderColorRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import copy from 'copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function ClientBillingInfo() {

    const location = useLocation();
    const [clientCardData, setClientCardData] = useState<any>();
    const [clientComments, setClientComments] = useState<Array<any>>([]);
    const [logoCard, setCardLogo] = useState<string>();
    const [comment, setComment] = useState<string>("");
    const [showEditComment, setShowEditComment] = useState<boolean>(false);
    const [showDeleteComment, setShowDeleteComment] = useState<boolean>(false);
    const [concretComment, setConcretComment] = useState<any>({});

    const getClientData = async () => {
        const clientData = await findClientById(location.state.id);
        if (clientData) setClientCardData(clientData.data.creditCard);
    }

    const getAllClientComments = async () => {
        const responseData = await getAllComments(location.state.id);
        if (responseData) {
            const dataUpdate = responseData.data.map((comment: any) => { return { ...comment, active: false }})
            setClientComments(dataUpdate);
        }
    }

    const logout = () : void => {
        localStorage.removeItem("tkn");
        localStorage.removeItem("reftkn");
        localStorage.removeItem("roles");
        window.location.reload();
    }

    useEffect(() => {
        getClientData().then(r => r);
        getAllClientComments().then(r => r);

        const timeout = setTimeout(() => {
            logout();
        }, 20 * 60  * 1000);

        return () => {
            clearTimeout(timeout);
        }
    }, [])

    useEffect(() => {
        if (clientCardData && clientCardData.creditCardNumbers) {
            if (clientCardData.creditCardNumbers.startsWith('3')) {
                setCardLogo(americanExpress);
            }
            else if (clientCardData.creditCardNumbers.startsWith('4')) {
                setCardLogo(visa);
            }
            else if (clientCardData.creditCardNumbers.startsWith('5')) {
                setCardLogo(masterCard);
            }
            else if (clientCardData.creditCardNumbers.startsWith('6')) {
                setCardLogo(discover);
            }
            else if (clientCardData.creditCardNumbers === '') {
                setCardLogo('');
            }
        }
    }, [clientCardData])

    const submitComment = async (): Promise<void> => {
        const requestData = {
            clientId: location.state.id,
            text: comment
        }
        const responseData = await addComment(requestData);
        if (responseData) {
            setComment("");
            await getAllClientComments();
        }
    }

    const updateSignupDate = (date: string) => {
        if (date) return new Date(date).toLocaleDateString("en-US");
        else return "";
    }

    const deleteCommentData = async (comment: any): Promise<void> => {
        setConcretComment(comment);
        setShowDeleteComment(true);
    }

    const editComment = (comment: any) => {
        setConcretComment(comment);
        setShowEditComment(true);
    }

    const copyLink = (value: string) => {
        copy(value.replaceAll("-", ""), {
            debug: false,
        });
    }

    return (
        <div className = "billingSheet">
            <Header />
            <div className = "credit-card-info-container">
                <div className = "createClient-header">
                    <span className = "createClientLeftArrowBox">
                        <KeyboardArrowLeftIcon
                            style = {{
                                color: "#004DE7"
                            }}
                            onClick = { () => window.history.back() }
                        />
                    </span>
                    <h2> CREDIT CARD INFORMATION </h2>
                </div>
                {
                    clientCardData ?
                    <div className = "credit-card-info-main-box">
                        <span className = "clientInfoSpan">
                            <p className = "clientInfoTitleText">Cardholder Name</p>
                            <p className = "clientInfoDataText">{ clientCardData.cardholderName }</p>
                        </span>
                        <span className="clientInfoSpan">
                            <p className="clientInfoTitleText">Credit Card Numbers</p>
                            <p
                                className = "clientInfoDataText"
                                style = {{
                                    display: "flex"
                                }}
                            >
                                { clientCardData.creditCardNumbers }
                                <img
                                    src = { logoCard }
                                    style = {{
                                        maxWidth: "50px",
                                        maxHeight: "20px",
                                        marginLeft: "10px",
                                        objectFit: "contain"
                                    }}
                                    alt = ""
                                />
                                <ContentCopyIcon
                                    className = "copyClientCardNumber"
                                    onClick = {() => copyLink(clientCardData.creditCardNumbers)}
                                    titleAccess = "Copy"
                                    style = {{
                                        fontSize: "20px"
                                    }}
                                />
                            </p>
                        </span>
                        <div className="cardCvvAndDateData">
                            <span className="clientInfoSpan cardDataSpan">
                                <p className="clientInfoTitleText">CVV</p>
                                <p className="clientInfoDataText">{ clientCardData.cvv }</p>
                            </span>
                            <span className="clientInfoSpan cardDataSpan">
                                <p className="clientInfoTitleText">Billing Address / Zip Code</p>
                                <p className="clientInfoDataText">{ clientCardData.billingAddress }</p>
                            </span>
                            <span className = "clientInfoSpan cardDataSpan">
                                <p className = "clientInfoTitleText">Expiration Date</p>
                                <p className = "clientInfoDataText">{ clientCardData.expirationDate }</p>
                            </span>
                        </div>
                        <div className = "cardCvvAndDateData">
                            <span className = "clientInfoSpan cardDataSpan">
                                <p className = "clientInfoTitleText">Sign Up Date</p>
                                <p className = "clientInfoDataText">{ updateSignupDate(clientCardData.signUpDate) }</p>
                            </span>
                            <span className = "clientInfoSpan cardDataSpan">
                                <p className = "clientInfoTitleText">Billing Date</p>
                                <p className = "clientInfoDataText">{ clientCardData.billingDate }</p>
                            </span>
                        </div>
                        <span className = "clientInfoSpan">
                            <p className = "clientInfoTitleText">Monthly Recurring</p>
                            <p className = "clientInfoDataText">{ "$" + " " + clientCardData.monthlyRecurring }</p>
                        </span>
                        <span className = "clientInfoSpan">
                            <p className = "clientInfoTitleText">Billing Notes</p>
                            <p className = "clientInfoDataText">{ clientCardData.billingNotes }</p>
                        </span>
                        {
                            clientComments.length > 0 &&
                                <span className = "clientInfoSpan">
                                    <p className = "clientInfoTitleText">Comments</p>
                                    {
                                        clientComments.map((comment: any) => {
                                            return <p className = "clientInfoDataText clientInfoCommentText">
                                                {
                                                    new Date(comment.creationDate).toLocaleDateString("en-US", {
                                                        month: "2-digit",
                                                        day: "2-digit",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    }).replaceAll("/", ".") + " - " + comment.text
                                                }
                                                <span className = "clientInfoCommentIconBox">
                                                    <BorderColorRoundedIcon
                                                        className = "clientInfoCommentIcon"
                                                        onClick = {() => editComment(comment)}
                                                    />
                                                    <DeleteIcon
                                                        className = "clientInfoCommentIcon"
                                                        onClick = {() => deleteCommentData(comment) }
                                                    />
                                                </span>
                                            </p>
                                        })
                                    }
                                </span>
                        }
                        <span
                            className = "clientInfoSpan"
                            style = {{ margin: '0' }}
                        >
                            <p className = "clientInfoTitleText">Add Comment</p>
                            <input
                                type = "text"
                                className = "add-comment-in-credit-card-page"
                                value = { comment }
                                onChange = { event => setComment(event.target.value) }
                            />
                            <button
                                className = "user-pin-code-button"
                                style = {{
                                    margin: "0 15px"
                                }}
                                onClick = { submitComment }
                            >
                                Submit
                            </button>
                        </span>
                    </div>
                        :
                    <div className = "credit-card-info-main-box no-data-text-box">
                        No Information
                    </div>
                }
            </div>
            {
                concretComment.id &&
                    <EditComment
                        showEditComment = { showEditComment }
                        setShowEditComment = { setShowEditComment }
                        concretComment = { concretComment }
                        setConcretComment = { setConcretComment }
                        getAllClientComments = { getAllClientComments }
                        clientId = { clientCardData.id }
                    />
            }
            {
                concretComment.id &&
                    <DeleteComment
                        showDeleteComment = { showDeleteComment }
                        setShowDeleteComment = { setShowDeleteComment }
                        concretComment = { concretComment }
                        setConcretComment = { setConcretComment }
                        getAllClientComments = { getAllClientComments }
                    />
            }
        </div>
    )
}

export default ClientBillingInfo
